import React from 'react';
import { setPostKyc } from '../../../../store/thunk/setPostKyc';
import { setGetKyc } from '../../../../store/thunk/setGetKyc';
import { useDispatch } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './helper';

const Cancel = ({cancel, setCancel, setDescriptionArea, descriptionArea, id}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    return (
        <Dialog maxWidth={600} onClose={() => setCancel(false)} open={cancel}>
            <div className={classes.root}>
                <div className={classes.flexBox}>
                    <span>Причина отказа</span>
                </div>
                <div>
                    <textarea 
                        name="" 
                        id="" 
                        rows="10"
                        value={descriptionArea}
                        onChange={(v) => setDescriptionArea(v.target.value)}
                        className={classes.text}
                    ></textarea>
                </div>
                <div className={classes.wrap}>
                    <span 
                        className={classes.send}
                        onClick={async () => {
                            await dispatch(setPostKyc({
                                type: 'cancel',
                                id,
                                descriptionArea
                            }))
                            setCancel(false);
                            setDescriptionArea('')
                            dispatch(setGetKyc({
                                page: 1,
                                rowsPerPage: 10,
                                search: ''
                            }))
                        }}    
                    >Отправить</span>
                </div>
            </div>
        </Dialog>
    )
}

export default Cancel;